/* eslint-disable lit/no-legacy-template-syntax */
// on-demand-topic is not an event handler - not legacy syntax
import { html, ifDefined } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import footer from './partials/footer.js';
import megaMenu from './partials/megaMenu.js';
import header from './partials/header.js';
import '../components/BreadcrumbsBar.js';
import '../components/MaintenanceMessage.js';
import '../components/MasterSnMessage.js';
import '../components/OutagesMessage.js';
import '../components/SnPicker.js';
import { infrastructure } from '../infrastructure.js';

/**
 * @param {TemplateResult} content
 * @param {Breadcrumb[]} breadcrumbs
 * @param {string} activeMenuItem
 * @param {?string} heading
 * @param {string} path
 * @param {boolean} shouldRenderSnPicker
 * @param {string} snPickerOnDemandTopic
 * @param {URLSearchParams} query
 * @returns {TemplateResult}
 */
export default function renderLayout({
  content,
  breadcrumbs,
  activeMenuItem,
  heading,
  path,
  shouldRenderSnPicker,
  snPickerOnDemandTopic,
  query,
}) {
  return html`
    ${megaMenu(activeMenuItem)}
    <osk-breadcrumbs-bar .breadcrumbs=${breadcrumbs}></osk-breadcrumbs-bar>
    ${heading ? header(heading) : null}
    ${shouldRenderSnPicker
      ? html`<osk-sn-picker
          .infrastructure=${infrastructure}
          .query=${query}
          return-state=${path}
          on-demand-topic=${ifDefined(snPickerOnDemandTopic)}
        ></osk-sn-picker>`
      : null}
    <main id="main" role="main" aria-live="polite">${content}</main>
    <osk-maintenance-message></osk-maintenance-message>
    <osk-master-sn-message></osk-master-sn-message>
    <osk-outages-message .infrastructure=${infrastructure}></osk-outages-message>
    ${footer()}
  `;
}
